import React from 'react';
import { IconProps } from './model/IconInterface';

const InvoiceIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill}) => {
  return (
    <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill ? color : 'none'}
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="2" width="18" height="20" rx="2" ry="2" />
    <path d="M9 2v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V2" />
    <line x1="9" y1="12" x2="15" y2="12" />
    <line x1="9" y1="16" x2="15" y2="16" />
  </svg>
  );
};

export default InvoiceIcon;